import { FC } from "react";

import CodeItem from "web/Components/Common/CodeItem";

import { ICartParentProductAttribute } from "web/types/Cart";
import { ProductCodeStatus } from "web/types/Code";
import { IParsedCodeItem, OrderStatus } from "web/types/Order";
import { PaymentStatus } from "web/types/Payment";

interface ICustomerCodeListListItemMobile {
  link?: string;
  name: string;
  image?: string;
  expirationDate: string;
  userUsed: number;
  itemId: number;
  options?: { attribute: ICartParentProductAttribute }[];
  codeDetails: IParsedCodeItem;
  supplierId: string;
  dataT1: string;
  productStatus: ProductCodeStatus;
  producSuperOptions?: IParsedCodeItem;
  orderStatusCode?: OrderStatus;
  paymentStatus: PaymentStatus;
}

const CustomerCodeListListItemMobile: FC<ICustomerCodeListListItemMobile> = ({
  link = "",
  name,
  image = "",
  expirationDate,
  userUsed,
  itemId,
  options,
  codeDetails,
  supplierId,
  dataT1,
  productStatus,
  producSuperOptions = {},
  orderStatusCode = "" as OrderStatus,
  paymentStatus = "" as PaymentStatus,
}) => {
  return (
    <>
      <CodeItem
        link={link}
        name={name}
        image={image}
        supplierId={supplierId}
        expirationDate={expirationDate}
        userUsed={userUsed}
        itemId={itemId}
        options={options}
        paymentStatus={paymentStatus}
        codeDetails={codeDetails}
        dataT1={dataT1}
        productStatus={productStatus}
        producSuperOptions={producSuperOptions}
        orderStatusCode={orderStatusCode}
      />
    </>
  );
};

export default CustomerCodeListListItemMobile;
